// This is a temporary file until the projects brief react app is in the SPA

// These types and consts are required for the layout primitives that aren't currently exposed by FEC

import { spaces } from '@99designs/common/core/settings';

export const spaceTextLarge = '1.6rem';
export const spaceTextSmall = '0.8rem';

export type Space =
    | 'none'
    | 'space2'
    | 'space3'
    | 'space4'
    | 'space5'
    | 'space6'
    | 'space7'
    | 'space8'
    | 'space9'
    | 'space10'
    | 'space11'
    | 'space12'
    | 'space13'
    | 'space14'
    | 'space15'
    | 'space16'
    | 'quarterGutter'
    | 'halfGutter'
    | 'gutter'
    | 'doubleGutter'
    | 'oneAndHalfGutter'
    | 'tripleGutter'
    | 'textLarge'
    | 'textSmall'
    | 'auto';

// These records should include units as they are used directly in Styled Components CSS
export const sizes: Record<Space, string> = {
    none: '0',
    space2: spaces.space2 + 'px',
    space3: spaces.space3 + 'px',
    space4: spaces.space4 + 'px',
    space5: spaces.space5 + 'px',
    space6: spaces.space6 + 'px',
    space7: spaces.space7 + 'px',
    space8: spaces.space8 + 'px',
    space9: spaces.space9 + 'px',
    space10: spaces.space10 + 'px',
    space11: spaces.space11 + 'px',
    space12: spaces.space12 + 'px',
    space13: spaces.space13 + 'px',
    space14: spaces.space14 + 'px',
    space15: spaces.space15 + 'px',
    space16: spaces.space16 + 'px',
    quarterGutter: spaces.quarterGutter + 'px',
    halfGutter: spaces.halfGutter + 'px',
    gutter: spaces.gutter + 'px',
    doubleGutter: spaces.doubleGutter + 'px',
    oneAndHalfGutter: spaces.oneAndHalfGutter + 'px',
    tripleGutter: spaces.tripleGutter + 'px',
    textLarge: spaceTextLarge,
    textSmall: spaceTextSmall,
    auto: 'auto',
};
